import { Form, Input, message, Modal } from "antd";
import Service, { ElAdminEventLogService } from "../../services";
import React, { useEffect, useState } from "react";

const ApiKeysModal = ({ apiKeyAccount, closeModal }) => {
  const [form] = Form.useForm();
  const [rsaPublicKey, setRsaPublicKey] = useState("");

  useEffect(() => {
    async function fetchRsaPublicKey() {
      const rsaPublicKey = await Service.fetchRsaPublicKey();
      setRsaPublicKey(rsaPublicKey);
    }
    fetchRsaPublicKey();
  }, []);

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 13 },
  };

  return (
    <Modal
      width={640}
      open={true}
      title="Update API Keys"
      okText="Confirm"
      cancelText="Cancel"
      onCancel={closeModal}
      onOk={() => {
        form
          .validateFields()
          .then((formParams) => {
            return Service.updateApiKeys({ rsaPublicKey, ...formParams });
            // form.resetFields();
          })
          .then((response) => {
            if (!response || typeof response !== "string") {
              console.log({ response });
              throw new Error(`Something is wrong: response is malformed`);
            }
            closeModal();
            message.success(`API Keys were updated successfully.`);
            return ElAdminEventLogService.saveUpdateApiKeysEvent(apiKeyAccount);
          })
          .catch((error) => {
            console.log("Validate Failed:", error);
            console.log(error);
            message.error(error.message ? error.message : String(error));
          });
      }}
    >
      <Form
        {...layout}
        form={form}
        initialValues={{
          exchangeAccount: apiKeyAccount,
        }}
      >
        <Form.Item label="Exchange Account" name="exchangeAccount">
          <Input disabled={true} />
        </Form.Item>
        <Form.Item label="Read API Key" name="readApiKey">
          <Input placeholder="input read api key" />
        </Form.Item>
        <Form.Item label="Read API Secret" name="readApiSecret">
          <Input placeholder="input read api secret" />
        </Form.Item>
        {apiKeyAccount?.startsWith("okx") && (
          <Form.Item label="Read API Passphrase" name="readApiPassword">
            <Input placeholder="input read api passphrase" />
          </Form.Item>
        )}
        <Form.Item label="Trade API Key" name="tradeApiKey">
          <Input placeholder="input trade api key" />
        </Form.Item>
        <Form.Item label="Trade API Secret" name="tradeApiSecret">
          <Input placeholder="input trade api secret" />
        </Form.Item>
        {apiKeyAccount?.startsWith("okx") && (
          <Form.Item label="Trade API Passphrase" name="tradeApiPassword">
            <Input placeholder="input trade api passphrase" />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default ApiKeysModal;
